import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { jobs_helper } from "@/helpers/jobs_helper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import styles from "./styles.module.scss";
import JobCard from "@/components/JobCard";
import Button from "@/components/Button";
import Title from "@/ui/Title";

SwiperCore.use([Navigation, Autoplay]);

export const LatestJobsFilter = ({ title, variant = "tertiary", specialismIds = [], internal, limit = 5 }) => {
  const fetchParams = { limit };
  if (specialismIds.length > 0) {
    fetchParams.specialty = specialismIds;
  }

  if (internal) {
    fetchParams.filter = (job) => job.categories.some((cat) => cat.name === "Internal Jobs");
  }

  const jobs = jobs_helper.fetch(fetchParams);

  const breakpoints = {
    500: { slidesPerView: 1 },
    760: { slidesPerView: 2 },
    1150: { slidesPerView: 3 },
    1240: { slidesPerView: 4 },
  };

  return (
    <section id="LatestJobsFilter" className={styles.LatestJobs}>
      <div className={styles.title_header}>
        <Title
          title={title || "Latest Jobs"}
          tag="h3"
          highlight={false}
          variant={variant ?? "primary"}
          className={`h2 ${variant ?? "primary"} text-center`}
        />
      </div>
      <div className={styles.carousel}>
        <div className={styles.wrapper}>
          <Swiper
            loop
            speed={5000}
            spaceBetween={10}
            breakpoints={breakpoints}
            autoplay={{
              delay: 1,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
              stopOnLastSlide: false,
            }}
          >
            {jobs.map((job, i) => (
              <SwiperSlide key={i}>
                <JobCard job={job} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className={styles.more_jobs_btn}>
        <Button display="View All Jobs" link="/jobs" />
      </div>
    </section>
  );
};

export default LatestJobsFilter;
